export default __webpack_public_path__ + "static/media/favicon.72491e65.ico";